/*
 * @Author: YuanYuan
 * @Date: 2024-02-23 16:44:55
 * @LastEditTime: 2025-09-29 15:29:56
 * @description: 网站接入常量定义
 */
import i18n from '@/i18n'

export default [
  {
    name: 'StatusOptions',
    value: [
      { label: i18n.t('common.deploying'), value: '0', colorClazz: 'text-color-gold' }, // 部署中
      { label: i18n.t('common.effective'), value: '1', colorClazz: 'text-color-success' }, // 已生效
      // { label: i18n.t('common.reviewing'), value: '2', colorClazz: 'text-color-gold' }, // 审核中
      { label: i18n.t('common.accessing'), value: '3' , colorClazz: 'text-color-primary' }, // 接入中
      { label: i18n.t('common.stopped'), value: '2', colorClazz: 'text-color-error' }, // 已停用
    ]
  },
  {
    name: 'HttpsStatusOptions',
    value: [
      { label: i18n.t('common.hasBeenSet'), value: '1', bgClazz: 'bg-color-success', colorClazz: 'text-color-success' }, // 已开启
      { label: i18n.t('common.notSet'), value: '0', bgClazz: 'bg-color-info', colorClazz: 'text-color-info' } // 未开启
    ]
  },
  {
    name: "SourceTypeOptions",
    value: [
      { label: 'IP', value: 1 }, // IP
      { label: i18n.t('common.domain'), value: 2 } // 域名
    ]
  },
  {
    name: 'ProtocolOptions',
    value: [
      { label: 'HTTP', value: '0', disabled: true },
      { label: 'HTTPS', value: '1', disabled: false }
    ]
  },
  {
    name: "AccelerateConfigOptions",
    value: [
      { label: i18n.t('common.defaultConfig'), value: 0, tips: i18n.t('website.defaultAcceConfigTips') }, // 默认配置
      { label: i18n.t('website.referExistedDomain'), value: 1 } // 参照已有域名
    ]
  },
  {
    name: 'DefendConfigOptions',
    value: [
      { label: i18n.t('common.recommendConfig'), value: 'SYSTEM' }, // 推荐配置
      { label: i18n.t('website.referExistedDomain'), value: 'REFER' } // 参照已有域名
    ]
  },
  {
    name: 'CacheTypeOptions',
    value: [
      { label: i18n.t('website.spCommonType'), value: 0 }, // 指定常用类型
      { label: i18n.t('website.fileType'), value: 1 }, // 文件类型
      { label: i18n.t('website.spURI'), value: 2 }, // 指定URI
      { label: i18n.t('website.spDirectory'), value: 3 }, // 指定目录
      { label: i18n.t('website.urlPattern'), value: 4 } // URL匹配模式
    ]
  },
  {
    name: 'CacheCommonOptions',
    value: [
      { label: i18n.t('website.allReq'), value: '.*' }, // 所有请求
      { label: i18n.t('website.onlyHomepage'), value: '$' } // 仅主页
    ]
  },
  {
    name: 'FileTypeOptions',
    value: [
      { label: 'gif', value: 'gif' },
      { label: 'png', value: 'png' },
      { label: 'bmp', value: 'bmp' },
      { label: 'jpeg', value: 'jpeg' },
      { label: 'jpg', value: 'jpg' },
      { label: 'html', value: 'html' },
      { label: 'htm', value: 'htm' },
      { label: 'shtml', value: 'shtml' },
      { label: 'mp3', value: 'mp3' },
      { label: 'wma', value: 'wma' },
      { label: 'flv', value: 'flv' },
      { label: 'mp4', value: 'mp4' },
      { label: 'wmv', value: 'wmv' },
      { label: 'zip', value: 'zip' },
      { label: 'exe', value: 'exe' },
      { label: 'rar', value: 'rar' },
      { label: 'css', value: 'css' },
      { label: 'txt', value: 'txt' },
      { label: 'ico', value: 'ico' },
      { label: 'js', value: 'js' },
      { label: 'swf', value: 'swf' },
      { label: 'xml', value: 'xml' },
      { label: 'bootstarp', value: 'bootstarp' },
      { label: 'ts', value: 'ts' }
    ]
  },
  {
    name: 'CacheTimeOptions',
    value: [
      { label: i18n.t('website.cacheFixedTime'), value: 1 }, // 缓存固定时间
      { label: i18n.t('website.noCache'), value: 0 } // 不缓存
    ]
  },
  {
    name: 'CacheTimeUnitOptions',
    value: [
      { label: i18n.t('website.second'), value: 's' }, // 秒
      { label: i18n.t('website.minute'), value: 'm' }, // 分钟
      { label: i18n.t('website.hour'), value: 'h' }, // 小时
      { label: i18n.t('website.day'), value: 'd' } // 天
    ]
  },
  {
    name: 'ClientRefreshOptions',
    value: [
      { label: i18n.t('website.changeToSince'), value: 1 }, // 转成 if-modified-since
      { label: i18n.t('website.ignore'), value: 0 } // 忽略
    ]
  },
  {
    name: 'ExptUAOptions',
    value: [
      { label: 'UA', value: 0 }, // UA
      { label: i18n.t('website.exptUA'), value: 1 } // 例外的UA
    ]
  },
  {
    name: 'ExptUrlOptions',
    value: [
      { label: i18n.t('website.exptUrlReg'), value: 1 } // 例外的URL（正则）
    ]
  },
  {
    name: 'ExptReqHeadOptions',
    value: [
      { label: i18n.t('website.reqHeader'), value: 0 }, // 请求头
      { label: i18n.t('website.exptReqHeader'), value: 1 } // 例外的请求头
    ]
  },
  {
    name: 'UriMatchModeOptions',
    value: [
      { label: i18n.t('website.exactMatch'), value: 0 }, // 精准匹配
      { label: i18n.t('website.ignoreParamMatch'), value: 1 } // 忽略参数匹配
    ]
  },
  {
    name: 'UrlPatternOptions',
    value: [
      { label: i18n.t('website.allUrl'), value: 0 }, // 所有URL
      { label: i18n.t('common.customize'), value: 1 } // 自定义
    ]
  },
  {
    name: 'ReqRewriteOptions',
    value: [
      { label: 'HTTP -> HTTPS', value: 1 },
      { label: 'HTTPS -> HTTP', value: 2 },
      { label: i18n.t('website.urlRewrite'), value: 3 } // URL改写
    ]
  },
  {
    name: 'AdvancedMatchRangeOptions',
    value: [
      { label: 'UA', value: 'ua', plsh: i18n.t('common.splitLine'), type: 'textarea' },
      { label: i18n.t('website.exptUA'), value: 'exceptionUA', plsh: i18n.t('common.splitLine'), type: 'textarea' },
      { label: i18n.t('website.reqHeader'), value: 'requestHeader', plsh: i18n.t('website.exptReqHeaderPlsh'), type: 'textarea' },
      { label: i18n.t('website.exptReqHeader'), value: 'expRequestHeader', plsh: i18n.t('website.exptReqHeaderPlsh'), type: 'textarea' },
      { label: i18n.t('account.country'), value: 'operatorsArea', plsh: i18n.t('common.plsInputKeyword'), type: 'country' },
      { label: i18n.t('website.exptCountry'), value: 'operatorsAreaExp', plsh: i18n.t('common.plsInputKeyword'), type: 'country' },
      { label: i18n.t('website.exptUrlReg'), value: 'exceptionUrl', plsh: i18n.t('website.exceptionUrlPlsh'), type: 'textarea' },
    ]
  },
  {
    name: 'ProtocolReplaceOptions',
    value: [
      { label: i18n.t('website.follow'), value: 'follow' },
      { label: 'HTTP->HTTPS', value: '1' },
      { label: 'HTTPS->HTTP', value: '0' }
    ]
  }
]
